import type { FaireBrandEntity } from "../../entity_types/brand";

export const hudsonValleyCandles: FaireBrandEntity = {
  token: "hudson-valley-candles",
  type: "brand",
  name: "Hudson Valley Candles",
  description: "Hand-poured soy candles with unique scents",
  rating: 4.8,
  location: "Hudson Valley, NY",
  minimumOrderDollars: 100,
  tags: ["candles", "handmade", "soy"],
  categoryTokens: ["cat_accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
